import { NavLink, Link } from "react-router-dom";
import { Brand, LocationSelector } from "../UI";
import { useApp } from "../../store";

export default function Topbar() {
  const { user } = useApp();
  const profileLabel = user?.name || "Login";
  return (
    <header className="topbar">
      <div className="container-xl d-flex align-items-center justify-content-between">
        <Brand />
        <nav className="desktop-nav">
          <NavLink to="/home">Home</NavLink>
          <NavLink to="/protein-shakes">Protein Shakes</NavLink>
          <NavLink to="/fruits">Fresh Fruits</NavLink>
          <NavLink to="/deliveries">My Deliveries</NavLink>
        </nav>
        <div className="d-flex align-items-center gap-3">
          <div className="d-none d-lg-block"><LocationSelector /></div>
          <Link to={user?.uid ? "/profile" : "/login"} className="profile-chip">
            <i className="fa-regular fa-user" /> {profileLabel}
          </Link>
        </div>
      </div>
    </header>
  );
}
